<template>
  <base-extra :extra="extra">
    <template #price>
      <pu-price :price="extra.price" :display-original-price="true" />
      <span class="per-stay">{{ extra.pricingDisplay }}</span>
    </template>
  </base-extra>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { ChargeTypeExtra } from '../../../../campsite-details/types'

@Component
class ExtraDated extends Vue {
  @Prop({ required: true })
  extra: ChargeTypeExtra
}

export default toNative(ExtraDated)
</script>
